import { LogIn, ShieldCheck } from "lucide-react";

export function SignInView({
  configured,
  busy,
  error,
  onSignIn
}: {
  configured: boolean;
  busy: boolean;
  error?: string;
  onSignIn: () => Promise<void>;
}) {
  return (
    <section className="signin-gate" aria-labelledby="signin-title">
      <div className="signin-mark" aria-hidden="true">
        <ShieldCheck />
      </div>
      <p className="eyebrow">Espace personnel sécurisé</p>
      <h1 id="signin-title">Connectez-vous avant de parler</h1>
      <p>
        Votre compte Google protège vos notes, vos réglages et l’accès au traitement
        vocal. Rien n’est écrit sans être rattaché à votre compte.
      </p>
      <button
        className="button primary google-signin"
        type="button"
        disabled={!configured || busy}
        onClick={() => void onSignIn()}
      >
        <LogIn aria-hidden="true" />
        {busy ? "Redirection…" : "Continuer avec Google"}
      </button>
      {!configured && (
        <p className="inline-error" role="alert">
          L’authentification n’est pas encore configurée pour ce déploiement.
        </p>
      )}
      {error && (
        <p className="inline-error" role="alert">
          {error}
        </p>
      )}
      <div className="signin-safety">
        <strong>Garde-fous actifs</strong>
        <span>Session vérifiée, quotas persistants par compte et limites strictes.</span>
      </div>
    </section>
  );
}
